'use strict'

import Helper from '@/utils/helper'

class SaleItem {
  constructor({name, price, count, totalSum}) {
    Helper.checkString('SaleItem.name', name)

    this.name = name
    this.price = price
    this.count = count
    this.totalSum = totalSum
  }

  getName () {
    return this.name
  }

  getPrice () {
    return this.price
  }

  getCount () {
    return this.count
  }

  getTotalSum () {
    return this.totalSum
  }

  toString() {
    return 'SaleItem{' +
      'name=' + '\'' + this.name + '\'' +
      ', price=' + '\'' + this.price + '\'' +
      ', count=' + '\'' + this.count + '\'' +
      ', totalSum=' + '\'' + this.totalSum + '\'' +
      '}'
  }
}

export default SaleItem
